import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { tap } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable()
export class TranslocoMatPaginatorIntl extends MatPaginatorIntl {
  private translateService = inject(TranslocoService);

  constructor() {
    super();

    this.translateService
      .selectTranslateObject('mat-paginator')
      .pipe(
        untilDestroyed(this),
        tap((t) => {
          this.ofTranslation = t['of'];
          this.itemsPerPageLabel = t['items-per-page'];
          this.nextPageLabel = t['next'];
          this.previousPageLabel = t['previous'];
          this.lastPageLabel = t['last'];
          this.firstPageLabel = t['first'];
        }),
      )
      .subscribe();
  }

  ofTranslation = '';

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length == 0 || pageSize == 0) {
      return `0 ${this.ofTranslation} ${length}`;
    }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} ${this.ofTranslation} ${length}`;
  };
}
